// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3oleB","productName":"Table_productName__3hqaz"};